<template>
    <div class="container-img">
        <img
          class="hidden-pokemon"
          :src="imgSrc"
          alt="pokemon">
        <img
          v-if="showPokemon"
          class="fade-in"
          :src="imgSrc"
          alt="pokemon">
    </div>
</template>

<script>

export default {
    props: {
        pokemonId: {
            type: Number,
            required: true,
        },
        showPokemon: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    computed: {
        imgSrc(){
            return `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/dream-world/${this.pokemonId}.svg`
        }
    },
    setup() {
        
    },
}
</script>

<style scoped>

    .pokemon-container {
    height: 200px;
    }

    img {
        height: 200px;
        position: absolute;
        user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -webkit-user-drag: none;
        -webkit-user-select: none;
        filter: drop-shadow(5px 5px 3px #333);
    }

    .hidden-pokemon {
        filter: brightness(0);
    }

    .container-img{
        display: flex;
        justify-content: center;
        align-content: center;
        width: 100%;
        height: 200px;
    }

    @media (max-width: 600px){

        img {
            height: 170px;
        }
    }

</style>